import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

/**
 * Row Registry State
 * Stores the array of row IDs in their current display order
 * for efficient lookup during shift-click range selection without prop drilling.
 */

const initialState = {
  rowIds: []
};
const rowRegistrySlice = createSlice({
  name: 'rowRegistry',
  initialState,
  reducers: {
    setRowRegistry: (state, action) => {
      state.rowIds = action.payload;
    }
  }
});
export const rowRegistryReducer = rowRegistrySlice.reducer;
export const {
  setRowRegistry
} = rowRegistrySlice.actions;

// Selectors
export const getRowRegistryState = ({
  rowRegistry
}) => rowRegistry;
export const getRowIds = createSelector([getRowRegistryState], ({
  rowIds
}) => rowIds);
export const getRowIdsInRange = createSelector([getRowIds, (_state, startIndex) => startIndex, (_state, _startIndex, endIndex) => endIndex], (rowIds, startIndex, endIndex) => {
  const start = Math.min(startIndex, endIndex);
  const end = Math.max(startIndex, endIndex);
  return rowIds.slice(start, end + 1);
});